// PageExpired Component

import React, { Component } from 'react'

import IntlMessage from '../../common/intl/intl_message.jsx'

class PageExpired extends Component {
  constructor (props) {
    super(props)

    this.state = {
      contHgt: null
    }
  }

  handleResize () {
    const minheight = this.getWindowHeight()
    this.setState({ contHgt: { height: minheight } })
  }

  componentDidMount () {
    window.addEventListener('resize', this.handleResize.bind(this))
    this.handleResize()
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.handleResize)
  }

  getWindowHeight () {
    const windowHgt = window.innerHeight + 'px'

    return windowHgt
  }

  render () {
    return (
      <div className='page-expired' style={this.state.contHgt}>
        <div className='container'>
          <div className='content typo'>
            <h1 className='title'>
              <IntlMessage ident='user.signupTeam.expiredTitle' />
            </h1>
            <div className='content'>
              <p>
                <IntlMessage ident='user.signupTeam.expiredInfo' />
              </p>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default PageExpired
